import React from 'react';

import { Calendar, ConfigProvider } from 'antd';
import moment, { Moment } from 'moment';

import momentGenerateConfig from 'rc-picker/es/generate/moment';
import { getCalendarLanguage } from '@utils/UserUtils';
import { ISlotBooking } from '@common/domain/models/SlotBookingModel';
import './styles.less';

const MyCalendar = Calendar.generateCalendar<Moment>(momentGenerateConfig);

interface DateCalendarProps {
    onDateSelect: (date: string) => void;
    selectedDate: string;
    slotBooking: ISlotBooking[];
}

const maxYear = moment().add(1, 'month');
const today = moment().startOf('day').add(1, 'days');

const DateCalendar: React.FC<DateCalendarProps> = (props: DateCalendarProps) => {
    const { onDateSelect, selectedDate, slotBooking } = props;
    
    const activeDays = slotBooking?.length > 0 &&
        slotBooking[0]?.availability?.
            filter(slot => slot?.isActive && slot?.intervals.length > 0)
            .map(slot => slot.day.toLowerCase());

    const disabledDate = (current: Moment) => {
        const dayName = current.format('dddd').toLowerCase();
        const formattedDate = current.format('YYYY-MM-DD');

        const isDayDisabled = !activeDays.includes(dayName);
        const isOverriddenUnavailable = slotBooking[0]?.dateOverrides.some(
            (override) => override.isUnavailable && override.date === formattedDate
        );
        return isDayDisabled || isOverriddenUnavailable;
    };

    const onSelect = (value: Moment) => {
        onDateSelect(value.format('YYYY-MM-DD'));
    };

    return (
        <div className='my_calendar'>
            <ConfigProvider locale={getCalendarLanguage()}>
                <MyCalendar
                    fullscreen={false}
                    validRange={[today, maxYear]}
                    onChange={onSelect}
                    value={moment(selectedDate)}
                    disabledDate={disabledDate}
                />
            </ConfigProvider>
        </div>
    );
};

export default DateCalendar;
